import React from 'react';
import { Text, View } from 'react-native';
import { settingsStyles as styles } from '../settingsScreen.styles';
import {
  OperationalFilterChipGroup,
  OperationalFilterFieldLabel,
} from '../../../shared/filters/OperationalFilterPrimitives';
import { PaperSheet } from '../../../shared/ticket/PaperSheet';
import type { BranchSettingsScreenViewModel } from '../useBranchSettingsScreen';
import { hubStyles } from './settingsHubUi';

const BARCODE_OPTIONS = [
  { value: 'both' as const, label: 'Cámara y lector' },
  { value: 'camera' as const, label: 'Solo cámara' },
  { value: 'hardware' as const, label: 'Solo lector' },
];

/**
 * Lector de códigos — el lector USB se comporta como teclado: escanea y el
 * código entra solo al buscador de productos. Movido desde Reglas del POS.
 */
export function BarcodeReaderCard({ vm }: { vm: BranchSettingsScreenViewModel }) {
  return (
    <PaperSheet padded testID="branch.codes.card">
      <Text style={styles.cardTitle}>Lectura de códigos</Text>

      <View style={hubStyles.controlBlock}>
        <OperationalFilterFieldLabel>Cómo leer códigos</OperationalFilterFieldLabel>
        <Text style={hubStyles.hintSecondary}>
          Elegí cómo querés leer códigos. El cambio se aplica a toda la sucursal.
        </Text>
        <OperationalFilterChipGroup
          ticketTone
          layout="hug"
          options={BARCODE_OPTIONS.map((opt) => ({
            value: opt.value,
            label: opt.label,
            accessibilityLabel: `Lectura: ${opt.label}`,
          }))}
          value={vm.barcodeInputMode}
          disabled={!vm.canEditPosRules}
          onChange={(id) => {
            void vm.handleSaveBarcodeInputMode(id);
          }}
        />
        <Text style={hubStyles.hintMuted}>
          Los lectores USB o Bluetooth funcionan como un teclado.
        </Text>
      </View>
    </PaperSheet>
  );
}
